(() => {
  function initializeScrollCue(root) {
    const cues = root.matches?.('.mm-hero__scroll') ? [root] : root.querySelectorAll('.mm-hero__scroll');

    cues.forEach((cue) => {
      if (cue.dataset.initialized) return;
      cue.dataset.initialized = 'true';

      let scheduled = false;
      const update = () => {
        scheduled = false;
        if (!cue.isConnected) {
          window.removeEventListener('scroll', schedule);
          return;
        }
        const hidden = window.scrollY > 80;
        cue.classList.toggle('mm-hero__scroll--hidden', hidden);
        cue.inert = hidden;
        cue.setAttribute('aria-hidden', String(hidden));
      };
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      };

      window.addEventListener('scroll', schedule, { passive: true });
      schedule();
    });
  }

  function initializeHero(root = document) {
    initializeScrollCue(root);
    root.querySelectorAll('.mm-hero__video:not([data-initialized])').forEach((video) => {
      video.dataset.initialized = 'true';

      // The poster remains visible for reduced motion, data saving, and no-JavaScript visits.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;

      const start = () => {
        if (!video.isConnected || video.src) return;
        video.src = window.matchMedia('(max-width: 699px)').matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        video.play().catch(() => {});
      };

      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeHero(), { once: true });
  else initializeHero();

  document.addEventListener('shopify:section:load', (event) => initializeHero(event.target));
})();
